export default __webpack_public_path__ + "static/media/logo.ea3b30fd.png";